'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserHeaderNav = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactIntl = require('react-intl');

var _reactRouter = require('react-router');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseIcons = require('@bibliocommons/base-icons');

require('../styles/UserHeaderNav.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserHeaderNav = exports.UserHeaderNav = function (_BcReactComponent) {
  _inherits(UserHeaderNav, _BcReactComponent);

  function UserHeaderNav() {
    _classCallCheck(this, UserHeaderNav);

    return _possibleConstructorReturn(this, (UserHeaderNav.__proto__ || Object.getPrototypeOf(UserHeaderNav)).apply(this, arguments));
  }

  _createClass(UserHeaderNav, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          renderHeading = _props.renderHeading,
          renderIcon = _props.renderIcon,
          isCurrentUser = _props.isCurrentUser,
          items = _props.items,
          userIdentity = _props.userIdentity;

      var classNames = (0, _classnames2.default)('cp-user-header-nav', { 'home-patron': userIdentity.get('homePatron'), 'main-nav': items.size <= 0 });
      var exitLabel = isCurrentUser ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_my_profile' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_users_profile', values: { username: userIdentity.get('name') } });
      var profileURL = '/user_profile/' + userIdentity.get('id');

      return _react2.default.createElement(
        'div',
        { className: classNames },
        _react2.default.createElement(
          'a',
          { className: 'exit-link', href: profileURL },
          _react2.default.createElement(_baseIcons.Arrows.long.Left, { color: '#fff' }),
          _react2.default.createElement(
            _baseScreenReaderMessage2.default,
            null,
            exitLabel
          )
        ),
        _react2.default.createElement(
          'span',
          { className: 'heading', 'aria-hidden': 'true' },
          renderIcon(),
          ' ',
          renderHeading()
        ),
        _react2.default.createElement(
          'ul',
          { className: 'links-list hidden-xs' },
          items.map(function (navItem) {
            return _react2.default.createElement(
              'li',
              { key: navItem.get('key'), className: 'user-header-nav-item' },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: navItem.get('link'), activeClassName: 'active' },
                navItem.get('label')
              )
            );
          })
        )
      );
    }
  }]);

  return UserHeaderNav;
}(_baseBcReactComponent2.default);

var itemShape = _reactImmutableProptypes2.default.mapContains({
  key: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  label: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
  link: _react.PropTypes.string.isRequired
});

UserHeaderNav.propTypes = {
  renderHeading: _react.PropTypes.func.isRequired,
  renderIcon: _react.PropTypes.func.isRequired,
  isCurrentUser: _react.PropTypes.bool,
  items: _reactImmutableProptypes2.default.iterableOf(itemShape).isRequired,
  userIdentity: _bcPropTypes.userIdentityShape.isRequired
};

exports.default = UserHeaderNav;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-header/lib/components/user-header-nav/components/UserHeaderNav.component.js
// module id = 1553
// module chunks = 1